import { render, staticRenderFns } from "./SliderContained.vue?vue&type=template&id=054cb1bc&"
import script from "./SliderContained.vue?vue&type=script&lang=js&"
export * from "./SliderContained.vue?vue&type=script&lang=js&"
import style0 from "./SliderContained.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports